import { useCallback } from "react";

interface ShareOptions {
  title?: string;
  text?: string;
  url?: string;
}

/**
 * Hook to provide social sharing functionality with clipboard fallback.
 */
export const useSacredShare = () => {
  const share = useCallback(async (options: ShareOptions) => {
    if (typeof window === "undefined") return;

    if (navigator.share) {
      try {
        await navigator.share(options);
      } catch (err) {
        // Ignore abort errors which happen when user cancels
        if ((err as Error).name !== "AbortError") {
          console.error("Error sharing:", err);
        }
      }
    } else {
      // Fallback to clipboard
      const shareUrl = options.url || window.location.href;
      try {
        await navigator.clipboard.writeText(shareUrl);
        // In a real UI we might want a Toast here, but alert is consistent with existing logic
        alert("Link copied to clipboard!");
      } catch (err) {
        console.error("Clipboard fallback failed:", err);
      }
    }
  }, []);

  return { share };
};
